import { useEffect, useState } from "react"

//styling
import { Checkbox } from "primereact/checkbox"
import myStyles from "../../../styles/assessments/AssessmentScheduleForm.module.css"
import { Dropdown } from "primereact/dropdown"
import { useField } from "formik"
import { getCronTimeUtc } from "./scheduleHelpers"

export default function AssessmentScheduleMonthly({
  cronFieldName,
  timeValue,
  refreshCronStatement,
  disabled,
}) {
  const [field, , helpers] = useField(cronFieldName)

  const [isDayOf, setIsDayOf] = useState(true)
  const [day, setDay] = useState(1)
  const [dayString, setDayString] = useState(1)
  const [dayOfWeek, setDayOfWeek] = useState("MON")
  const [month, setMonth] = useState(1)

  useEffect(() => {
    if (field.value !== "") {
      let existingCron = field.value?.split(" ")

      if (existingCron.length === 5) {
        if (existingCron[4].includes("#")) {
          let dayBits = existingCron[4].split("#")
          setDayOfWeek(dayBits[0])
          setDayString(+dayBits[1])

          if (existingCron[3] === "*") {
            setMonth(1)
          } else {
            setMonth(+existingCron[3].replace("1/", ""))
          }

          setIsDayOf(false)
        } else {
          setIsDayOf(true)

          setDay(+existingCron[2])
          if (existingCron[3] === "*") {
            setMonth(1)
          } else {
            setMonth(+existingCron[3].replace("*/", ""))
          }
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let timeValues = getCronTimeUtc(timeValue)

    //Default cron is week days
    let newCron = `${timeValues} * * *`

    if (isDayOf) {
      newCron = `${timeValues} ${day} */${month} *`
    } else {
      let monthCron = month > 1 ? `1/${month}` : "*"

      newCron = `${timeValues} * ${monthCron} ${dayOfWeek}#${dayString}`
    }

    helpers.setValue(newCron)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDayOf, day, dayString, dayOfWeek, month, refreshCronStatement])

  return (
    <div className={myStyles.periodOptionContainer}>
      <div className={myStyles.periodOption}>
        <Checkbox
          checked={isDayOf}
          onChange={(e) => {
            setIsDayOf(e.checked)
          }}
          disabled={disabled}
        />{" "}
        Day{" "}
        <Dropdown
          value={day}
          options={[
            ...Array(31)
              .keys()
              .map((key) => key + 1),
          ]}
          onChange={(e) => {
            setIsDayOf(true)
            setDay(e.value)
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />{" "}
        of every{" "}
        <Dropdown
          value={month}
          options={[
            ...Array(12)
              .keys()
              .map((key) => key + 1),
          ]}
          onChange={(e) => {
            setIsDayOf(true)
            setMonth(e.value)
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />{" "}
        Month(s)
      </div>
      <div className={myStyles.periodOption}>
        <Checkbox
          checked={!isDayOf}
          onChange={(e) => {
            setIsDayOf(!e.checked)
          }}
          disabled={disabled}
        />{" "}
        The{" "}
        <Dropdown
          value={dayString}
          options={[
            { label: "First", value: 1 },
            { label: "Second", value: 2 },
            { label: "Third", value: 3 },
            { label: "Fourth", value: 4 },
          ]}
          onChange={(e) => {
            setIsDayOf(false)
            setDayString(e.value)
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />{" "}
        <Dropdown
          value={dayOfWeek}
          options={[
            { day: "Monday", cron: "MON" },
            { day: "Tuesday", cron: "TUE" },
            { day: "Wednesday", cron: "WED" },
            { day: "Thursday", cron: "THU" },
            { day: "Friday", cron: "FRI" },
            { day: "Saturday", cron: "SAT" },
            { day: "Sunday", cron: "SUN" },
          ]}
          optionLabel="day"
          optionValue="cron"
          onChange={(e) => {
            setIsDayOf(false)
            setDayOfWeek(e.value)
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />{" "}
        of every{" "}
        <Dropdown
          value={month}
          options={[
            ...Array(12)
              .keys()
              .map((key) => key + 1),
          ]}
          onChange={(e) => {
            setIsDayOf(false)
            setMonth(e.value)
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />{" "}
        Month(s)
      </div>
    </div>
  )
}
